import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/medal-bronze.svg'
import _imports_1 from '@/assets/svg/medal-silver.svg'
import _imports_2 from '@/assets/svg/medal-gold.svg'


const _withScopeId = n => (_pushScopeId("data-v-d5c05c00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "medal-progress-bar-root" }
const _hoisted_2 = { class: "medal-progress-bar" }
const _hoisted_3 = { class: "progress-bar" }

import ProgressBar from '../ProgressBar.vue'
import { QuizzMedal } from '@/types/Quizz'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    medal: null
  },
  setup(__props: any) {

const props = __props as {
  medal: QuizzMedal
}



const progress = computed(() => {
  switch (props.medal) {
    case QuizzMedal.BRONZE:
      return 33
    case QuizzMedal.SILVER:
      return 66
    case QuizzMedal.GOLD:
      return 100
    case QuizzMedal.NONE:
    default:
      return 0
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProgressBar, { progress: _unref(progress) }, null, 8, ["progress"]),
        _createElementVNode("img", {
          class: _normalizeClass(["medal-bronze", { disabled: _unref(progress) < 33 }]),
          src: _imports_0
        }, null, 2),
        _createElementVNode("img", {
          class: _normalizeClass(["medal-silver", { disabled: _unref(progress) < 66 }]),
          src: _imports_1
        }, null, 2),
        _createElementVNode("img", {
          class: _normalizeClass(["medal-gold", { disabled: _unref(progress) < 100 }]),
          src: _imports_2
        }, null, 2)
      ])
    ])
  ]))
}
}

})